
export default {
  name: 'NotFound',
  colorMode: 'light',
}
